import React, { Suspense, lazy, useEffect, useState } from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import { useSelector } from "react-redux";
import LoaderFade from "./components/loaders/LoaderFade";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";

const HomePage2 = lazy(() => import("./pages/Guest2/Home"));
const Login2 = lazy(() => import("./pages/User/Auth2/Login"));
const Register2 = lazy(() => import("./pages/User/Auth2/Register"));
const VerifyEmail = lazy(() => import("./pages/User/Auth2/VerifyEmail"));
const ForgotPasswordMember = lazy(() => import("./pages/User/Auth2/ForgotPasswordMember"));
const ForgotPasswordGuest = lazy(() => import("./pages/Guest2/Auth/ForgotPasswordGuest"));
const ResetPasswordMember = lazy(() => import("./pages/User/Auth2/ResetPasswordMember"));
const ResetPasswordGuest = lazy(() => import("./pages/Guest2/Auth/ResetPasswordGuest"));
const ReferralSignup = lazy(() => import("./pages/User/Auth2/ReferralSignup"));
const ReplicatedSite = lazy(() => import("./pages/Guest2/ReplicatedSite"));
const Shop = lazy(() => import("./pages/Guest2/Shop"));
const Cart2 = lazy(() => import("./pages/Guest2/Cart"));
const Checkout2 = lazy(() => import("./pages/Guest2/Checkout"));
const PageNotFound = lazy(() => import("./pages/Guest2/PageNotFound"));
const ContactUs = lazy(() => import("./pages/Guest2/ContactUs"));
const Faqs = lazy(() => import("./pages/Guest2/Faqs"));
const TermsCondition = lazy(() => import("./pages/Guest2/TermsCondition"));
const PrivacyPolicy = lazy(() => import("./pages/Guest2/PrivacyPolicy"));
const CeoMessage = lazy(() => import("./pages/Guest2/CeoMessage"));
const Team = lazy(() => import("./pages/Guest2/Team"));
const DonatedTo = lazy(() => import("./pages/Guest2/DonatedTo"));
const PeacecoinGives = lazy(() => import("./pages/Guest2/PeacecoinGives"));
const ModuleZero = lazy(() => import("./pages/Guest2/ModuleZero"));

const Ukraine = lazy(() => import("./pages/Guest2/Ukraine"));
const GuestOrderConfirmation = lazy(() => import("./pages/Guest2/Confirmation"));
const GuestOrderDeclined = lazy(() => import("./pages/Guest2/Declined"));
const GuestDashboard = lazy(() => import("./pages/Guest2/Dashboard/Home"));
const GuestProfile = lazy(() => import("./pages/Guest2/Dashboard/Profile"));
const GuestLedgerOrder = lazy(() => import("./pages/Guest2/Dashboard/Orders"));
const GuestOrderDetails = lazy(() => import("./pages/Guest2/Dashboard/OrderDetails"));
const GuestLedgerTransactions = lazy(() => import("./pages/Guest2/Dashboard/Transactions"));

// old guest front end pages
{
    /*
const HomePage = lazy(() => import('./pages/Guest/HomePage'));
const CeoPage = lazy(() => import('./pages/Guest/CeoPage'));
const TeamPage = lazy(() => import('./pages/Guest/TeamPage'));
const FaqPage = lazy(() => import('./pages/Guest/FaqPage'));
const ContactPage = lazy(() => import('./pages/Guest/ContactPage'));
const Cart = lazy(() => import('./pages/Guest/Cart'));
const Checkout = lazy(() => import('./pages/Guest/Checkout'));
const Confirmation = lazy(() => import('./pages/Guest/Confirmation'));
const UkrainePage = lazy(() => import('./pages/Guest/UkrainePage'));
const TermsPage = lazy(() => import('./pages/Guest/TermsPage'));
const PrivacyPage = lazy(() => import('./pages/Guest/PrivacyPage'));
const Login = lazy(() => import('./pages/User/Auth/Login'));
const Register = lazy(() => import('./pages/User/Auth/Register'));
const ForgotPassword = lazy(() => import('./pages/User/Auth/ForgotPassword'));
*/
}

const ApparelPage = lazy(() => import("./pages/Guest/ApparelPage"));
const JewelryPage = lazy(() => import("./pages/Guest/JewelryPage"));
const Blog = lazy(() => import("./pages/Guest/Blog"));
const BlogDetails = lazy(() => import("./pages/Guest/BlogDetails"));
const Dashboard = lazy(() => import("./pages/User/Dashboard/Home"));
const DashboardJoiningPackage = lazy(() => import("./pages/User/Dashboard/JoiningPackage"));
const DashboardWallet = lazy(() => import("./pages/User/Dashboard/Wallet"));
const DashboardCommission = lazy(() => import("./pages/User/Dashboard/Commission"));
const DashboardExchange = lazy(() => import("./pages/User/Dashboard/Exchange"));
const DashboardRewardPts = lazy(() => import("./pages/User/Dashboard/RewardPts"));
const DashboardSmartPackages = lazy(() => import("./pages/User/Dashboard/SmartPackages"));
const DashboardRetailPackages = lazy(() => import("./pages/User/Dashboard/RetailPackages"));
const DashboardDigitalMarketingPackages = lazy(() => import("./pages/User/Dashboard/DigitalMarketingPackages"));
const DashboardVipPackages = lazy(() => import("./pages/User/Dashboard/VipPackages"));
const DashboardIboPackages = lazy(() => import("./pages/User/Dashboard/IboPackages"));
const DashboardOtherPackages = lazy(() => import("./pages/User/Dashboard/OtherPackages"));
const DashboardNFTPackages = lazy(() => import("./pages/User/Dashboard/NftPackages"));
const DashboardRewards = lazy(() => import("./pages/User/Dashboard/Rewards"));
const DashboardCoins = lazy(() => import("./pages/User/Dashboard/Coins"));
const DashboardShop = lazy(() => import("./pages/User/Dashboard/Shop"));
const DashboardAutoPay = lazy(() => import("./pages/User/Dashboard/Autopay"));
const DashboardAnnouncement = lazy(() => import("./pages/User/Dashboard/Announcement"));
const DashboardAnnouncementDetails = lazy(() => import("./pages/User/Dashboard/AnnouncementDetails"));
const DashboardGenealogy = lazy(() => import("./pages/User/Dashboard/Genealogy"));
const DashboardReferredMembers = lazy(() => import("./pages/User/Dashboard/ReferredMembers"));
const DashboardUsersList = lazy(() => import("./pages/User/Dashboard/UsersList"));
const DashboardCart = lazy(() => import("./pages/User/Dashboard/Cart"));
const DashboardCheckout = lazy(() => import("./pages/User/Dashboard/Checkout"));
const DashboardConfirmation = lazy(() => import("./pages/User/Dashboard/Confirmation"));
const DashboardOrderDeclined = lazy(() => import("./pages/User/Dashboard/Declined"));
const DashboardLedgerOrder = lazy(() => import("./pages/User/Dashboard/Orders"));
const DashboardLedgerTransactions = lazy(() => import("./pages/User/Dashboard/Transactions"));
const DashboardOrderDetails = lazy(() => import("./pages/User/Dashboard/OrderDetails"));
const DashboardBonus = lazy(() => import("./pages/User/Dashboard/Bonus"));
const DashboardTrinaryCommission = lazy(() => import("./pages/User/Dashboard/TrinaryCommission"));
const DashboardTickets = lazy(() => import("./pages/User/Dashboard/Tickets"));
const DashboardTicketAdd = lazy(() => import("./pages/User/Dashboard/TicketAdd"));
const DashboardTicketConfirmation = lazy(() => import("./pages/User/Dashboard/TicketConfirm"));
// const DashboardTicketDetails = lazy(() => import('./pages/User/Dashboard/TicketDetails'));
const DashboardTicketDetailsNew = lazy(() => import("./pages/User/Dashboard/TicketDetailsNew"));
const DashboardPeaceCoinModules = lazy(() => import("./pages/User/Dashboard/PeaceCoinModules"));
const DashboardPeacecoinModuleCourses = lazy(() => import("./pages/User/Dashboard/PeaceCoinModuleCourses"));
const DashboardPeacecoinCourseDetails = lazy(() => import("./pages/User/Dashboard/PeaceCoinCourseDetails"));
const DashboardPeacecoinLectureFiles = lazy(() => import("./pages/User/Dashboard/PeaceCoinLectureFiles"));
const DashboardPeacecoinCourseQuiz = lazy(() => import("./pages/User/Dashboard/PeaceCoinCourseQuiz"));
const DashboardQuizConfirmation = lazy(() => import("./pages/User/Dashboard/QuizConfirmation"));
const DashboardNewAcademyModules = lazy(() => import("./pages/User/Dashboard/NewAcademyModules"));
const DashboardWithdrawPeacecoin = lazy(() => import("./pages/User/Dashboard/WithdrawPeacecoins"));
const DashboardWithdrawFunds = lazy(() => import("./pages/User/Dashboard/WithdrawFunds"));
const DashboardExecutiveTeam = lazy(() => import("./pages/User/Dashboard/ExecutiveTeam"));
const DashboardSuccessProfiles = lazy(() => import("./pages/User/Dashboard/SuccessProfiles"));
const DashboardProfile = lazy(() => import("./pages/User/Dashboard/Profile"));
const DashboardShipping = lazy(() => import("./pages/User/Dashboard/Shipping"));
const DashboardTrainingPdf = lazy(() => import("./pages/User/Dashboard/Training"));

function App() {

    const { user } = useSelector((state) => state.auth);
    const [isJoinPackage, setJoinPackage] = useState(1);
    const [isEmailVerified, setEmailVerified] = useState(true);

    useEffect(() => {
        if (user) {
            setJoinPackage(user.is_joining_package_purchase);
            if (user.email_verified_at === null) {
                setEmailVerified(false);
            } else {
                setEmailVerified(true);
            }
        }
    }, [user]);

    return (
        <Suspense fallback={<LoaderFade />}>
            <Router>
                <Routes>
                    <Route path="/" element={<HomePage2 />} />
                    <Route path="/ceo" element={<CeoMessage />} />
                    <Route path="/team" element={<Team />} />
                    <Route path="/donated-to" element={<DonatedTo />} />
                    <Route
                        path="/peacecoin-gives"
                        element={<PeacecoinGives />}
                    />
                    <Route
                        path="/module-zero"
                        element={<ModuleZero />}
                    />
                    <Route path="/referral/:username" element={<ReferralSignup />} />
                    <Route exact path="/pc/:username" element={<ReplicatedSite />} />
                    <Route path="/faqs" element={<Faqs />} />
                    <Route path="/contact" element={<ContactUs />} />
                    <Route path="/shop" element={<Shop />} />
                    <Route path="/apparel" element={<ApparelPage />} />
                    <Route path="/jewelry" element={<JewelryPage />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:id/details" element={<BlogDetails />} />
                    <Route path="/cart-guest" element={<Cart2 />} />
                    <Route path="/checkout-guest" element={<Checkout2 />} />
                    <Route
                        path="/guest/order/:id/complete"
                        element={<GuestOrderConfirmation />}
                    />
                    <Route
                        path="/guest/order/:id/declined"
                        element={<GuestOrderDeclined />}
                    />
                    <Route path="/ukraine" element={<Ukraine />} />
                    <Route
                        path="/terms-conditions"
                        element={<TermsCondition />}
                    />
                    <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                    <Route path="/login" element={<Login2 />} />
                    <Route path="/register" element={<Register2 />} />
                    <Route
                        path="/forgot-password/member"
                        element={<ForgotPasswordMember />}
                    />
                    <Route
                        path="/reset-password/member"
                        element={<ResetPasswordMember />}
                    />
                    <Route
                        path="/forgot-password/guest"
                        element={<ForgotPasswordGuest />}
                    />
                    <Route
                        path="/reset-password/guest"
                        element={<ResetPasswordGuest />}
                    />
                    <Route path="/verify-email" element={<VerifyEmail />} />
                    <Route
                        exact
                        path="/user/dashboard"
                        element={
                            isEmailVerified ? (
                                isJoinPackage === 1 ? (
                                    <Dashboard />
                                ) : (
                                    <Navigate
                                        replace
                                        to={"/user/joining-package"}
                                    />
                                )
                            ) : (
                                <Navigate replace to={"/verify-email"} />
                            )
                        }
                    />
                    <Route
                        path="/user/joining-package"
                        element={
                            isJoinPackage === 0 ? (
                                <DashboardJoiningPackage />
                            ) : (
                                <Navigate replace to={"/user/dashboard"} />
                            )
                        }
                    />
                    <Route
                        path="/user/wallet"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardWallet />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/commission"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardCommission />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/exchange"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardExchange />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/reward-pts"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardRewardPts />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/announcements/:type"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardAnnouncement />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/announcement/:slug/details"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardAnnouncementDetails />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/smart-packages"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardSmartPackages />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/retail-packages"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardRetailPackages />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/digital-marketing-packages"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardDigitalMarketingPackages />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/vip-packages"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardVipPackages />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/ibo"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardIboPackages />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/other-packages"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardOtherPackages />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/nfts"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardNFTPackages />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/reward-points"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardRewards />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/peacecoins"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardCoins />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/shop"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardShop />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/genealogy"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardGenealogy />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/referred-members"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardReferredMembers />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/genealogy/users"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardUsersList />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/auto-payments"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardAutoPay />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route path="/user/cart" element={<DashboardCart />} />
                    <Route
                        path="/user/checkout"
                        element={<DashboardCheckout />}
                    />
                    <Route
                        path="/user/order/:id/confirmation"
                        element={<DashboardConfirmation />}
                    />
                    <Route
                        path="/user/order/:id/declined"
                        element={<DashboardOrderDeclined />}
                    />
                    <Route
                        path="/user/ledger/orders"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardLedgerOrder />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/ledger/transactions"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardLedgerTransactions />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/order/:id/details"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardOrderDetails />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/bonuses"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardBonus />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/trinary-commission"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardTrinaryCommission />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/support/tickets"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardTickets />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/support/ticket/create"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardTicketAdd />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/support-ticket/:ticketId/confirmation"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardTicketConfirmation />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/support/ticket/:id/details"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardTicketDetailsNew />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/pc/modules"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardPeaceCoinModules />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/pc/:lang/module/:id/courses"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardPeacecoinModuleCourses />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/pc/:lang/course/:id/details"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardPeacecoinCourseDetails />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/pc/:lang/course/:id/file/:category"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardPeacecoinLectureFiles />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/pc/:lang/course/:id/quiz"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardPeacecoinCourseQuiz />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/quiz-complete/:id"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardQuizConfirmation />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/new/modules"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardNewAcademyModules />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/withdraw/peacecoins"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardWithdrawPeacecoin />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/withdraw/funds"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardWithdrawFunds />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/executive-team"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardExecutiveTeam />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/success-profiles"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardSuccessProfiles />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/profile"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardProfile />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/shipping"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardShipping />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/user/trainings/pdf"
                        element={
                            isJoinPackage === 1 ? (
                                <DashboardTrainingPdf />
                            ) : (
                                <Navigate
                                    replace
                                    to={"/user/joining-package"}
                                />
                            )
                        }
                    />
                    <Route
                        path="/guest/dashboard"
                        element={<GuestDashboard />}
                    />
                    <Route path="/guest/profile" element={<GuestProfile />} />
                    <Route
                        path="/guest/ledger/orders"
                        element={<GuestLedgerOrder />}
                    />
                    <Route
                        path="/guest/order/:id/details"
                        element={<GuestOrderDetails />}
                    />
                    <Route
                        path="/guest/ledger/transactions"
                        element={<GuestLedgerTransactions />}
                    />
                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </Router>
        </Suspense>
    );
}

export default App;
